import { render, staticRenderFns } from "./TablePlaceOfBusiness.vue?vue&type=template&id=f5328ff6&scoped=true&"
import script from "./TablePlaceOfBusiness.vue?vue&type=script&lang=js&"
export * from "./TablePlaceOfBusiness.vue?vue&type=script&lang=js&"
import style0 from "./TablePlaceOfBusiness.vue?vue&type=style&index=0&id=f5328ff6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5328ff6",
  null
  
)

export default component.exports